export default {
  app: {
    languagePopup: {
      title: 'Obecnie korzystasz z angielskiej wersji {logo}',
      subtitle: 'Czy chcesz przełączyć się na preferowany język?',
      cta: 'Przełącz na {lang}',
    },
  },
};
